import React from "react";

import {
  IonItem,
  IonSpinner,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonIcon,
} from "@ionic/react";

import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import { arrowRedoOutline, pinOutline } from "ionicons/icons";

import Alert from "../Alert";

import { PassageForm } from "../../interfaces/passage";
import { LocationInterface } from "../../interfaces/location";

import "./style.css";

interface FieldsLocationProps {
  form: PassageForm;
  onIonChange: (event: any) => void;
}

const GET_LOCATIONS = gql`
  query getLocations {
    getLocations {
      name
      id
      description
      price
      status
    }
  }
`;

const FieldLocations: React.FC<FieldsLocationProps> = ({
  form,
  onIonChange,
}) => {
  const { loading, error, data } = useQuery(GET_LOCATIONS, {
    fetchPolicy: "no-cache",
  });

  if (error) {
    return (
      <div className="fields-location">
        <Alert
          title="Alerta"
          error="network"
          content="Não foi possível carregar os dados de destinos"
        />
      </div>
    );
  }
  const list: Array<LocationInterface> = loading ? [] : data.getLocations;

  return (
    <div className="fields-location">
      <IonItem lines="inset">
        <IonIcon className="icon" slot="start" icon={arrowRedoOutline} />
        <IonLabel>Saída</IonLabel>
        {loading ? (
          <IonSpinner />
        ) : (
          <IonSelect
            value={form.departure_location_id}
            placeholder="Selecione"
            onIonChange={(e) =>
              onIonChange({
                ...e,
                detail: {
                  ...e.detail,
                  name: "departure_location_id",
                },
              })
            }
          >
            {list.map((location) => (
              <IonSelectOption
                key={`arrival_${location.id}`}
                value={location.id}
              >
                {location.name}
              </IonSelectOption>
            ))}
          </IonSelect>
        )}
      </IonItem>

      <IonItem lines="none">
        <IonIcon className="icon" slot="start" icon={pinOutline} />
        <IonLabel>Destino</IonLabel>
        {loading ? (
          <IonSpinner />
        ) : (
          <IonSelect
            value={form.arrival_location_id}
            placeholder="Selecione"
            onIonChange={(e) =>
              onIonChange({
                ...e,
                detail: {
                  ...e.detail,
                  name: "arrival_location_id",
                },
              })
            }
          >
            {list.map((location) => (
              <IonSelectOption
                key={`departure_${location.id}`}
                value={location.id}
              >
                {location.name}
              </IonSelectOption>
            ))}
          </IonSelect>
        )}
      </IonItem>
    </div>
  );
};

export default FieldLocations;
